import { Button } from '@southfields-digital/mpxlive-components';

import styles from '../Repeater.module.scss';

type RemoveButtonProps = {
  onClick: () => void;
};

const RemoveButton = ({ onClick }: RemoveButtonProps) => (
  <Button
    variant="icon"
    iconProps={{ icon: 'trash', weight: 'bold' }}
    color="white"
    onClick={onClick}
    className={styles.ButtonRemoveRow}
  />
);

export default RemoveButton;
